"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.regexp.exec");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getEnvironmentAsync = getEnvironmentAsync;
exports.getDomainBasedLocales = getDomainBasedLocales;
exports.getSupportedLanguagesAsync = getSupportedLanguagesAsync;
exports.getPrimaryProduct = getPrimaryProduct;
exports.getRoute = getRoute;
exports.getEnvironmentName = getEnvironmentName;
exports.load = exports.language = exports.constants = void 0;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

require("regenerator-runtime/runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _utils = require("../utils");

var _internals = require("../utils/internals");

var _constants = _interopRequireWildcard(require("./constants"));

var _language = _interopRequireWildcard(require("./language"));

var constants = _constants;
exports.constants = constants;
var language = _language;
exports.language = language;
var cachedGetEnvironment;

function getEnvironmentAsync() {
  return _getEnvironmentAsync.apply(this, arguments);
}

function _getEnvironmentAsync() {
  _getEnvironmentAsync = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    return _regenerator.default.wrap(function _callee2$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!cachedGetEnvironment) {
              cachedGetEnvironment = fetch(constants.url, {
                cache: 'force-cache',
                headers: (0, _utils.jsonHeaders)()
              }).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(response) {
                  return _regenerator.default.wrap(function _callee$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          return _context4.abrupt("return", response.json());

                        case 1:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }()).then(function (env) {
                if (!env.tokens) {
                  cachedGetEnvironment = null;
                }

                return env;
              });
            }

            return _context5.abrupt("return", cachedGetEnvironment);

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee2);
  }));
  return _getEnvironmentAsync.apply(this, arguments);
}

var load = getEnvironmentAsync;
exports.load = load;

function getDomainBasedLocales() {
  var _context, _context2;

  var countryCode = language.getCountryCode();
  return (0, _map.default)(_context = (0, _filter.default)(_context2 = language.supportedLanguagesMetadata).call(_context2, function (lang) {
    var _context3;

    return (0, _includes.default)(_context3 = lang.countryCodes).call(_context3, countryCode);
  })).call(_context, function (lang) {
    return lang.code;
  });
}

function getSupportedLanguagesAsync() {
  return _getSupportedLanguagesAsync.apply(this, arguments);
}

function _getSupportedLanguagesAsync() {
  _getSupportedLanguagesAsync = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    return _regenerator.default.wrap(function _callee3$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", getEnvironmentAsync().then(function (env) {
              var _context6;

              var locales = env.locales ? env.locales : getDomainBasedLocales();
              return (0, _filter.default)(_context6 = language.supportedLanguagesMetadata).call(_context6, function (lang) {
                return (0, _includes.default)(locales).call(locales, lang.code);
              });
            }));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee3);
  }));
  return _getSupportedLanguagesAsync.apply(this, arguments);
}

function getPrimaryProduct() {
  return _getPrimaryProduct.apply(this, arguments);
}

function _getPrimaryProduct() {
  _getPrimaryProduct = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
    return _regenerator.default.wrap(function _callee4$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", getEnvironmentAsync().then(function (env) {
              return env.primaryProduct || 'onvio';
            }));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee4);
  }));
  return _getPrimaryProduct.apply(this, arguments);
}

function getRoute(_x) {
  return _getRoute.apply(this, arguments);
}

function _getRoute() {
  _getRoute = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(routeName) {
    return _regenerator.default.wrap(function _callee5$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!(0, _utils.isNullOrEmpty)(routeName)) {
              _context9.next = 2;
              break;
            }

            return _context9.abrupt("return", _promise.default.resolve(''));

          case 2:
            return _context9.abrupt("return", getEnvironmentAsync().then(function (data) {
              var _data$RoutingTable;

              if ((_data$RoutingTable = data.RoutingTable) === null || _data$RoutingTable === void 0 ? void 0 : _data$RoutingTable[routeName]) {
                return data.RoutingTable[routeName];
              }

              return '';
            }));

          case 3:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee5);
  }));
  return _getRoute.apply(this, arguments);
}

var domainEnvPrefixExtractor = /https?:\/\/(.*?)\..*/;

function getEnvironmentName(env) {
  var _domainEnvPrefixExtra;

  var rootUrl = env.RoutingTable.Root;

  if (rootUrl === '' || rootUrl === undefined || rootUrl === null) {
    throw new Error('The Root route can not be found in the RoutingTable');
  }

  var _ref = (_domainEnvPrefixExtra = domainEnvPrefixExtractor.exec(rootUrl.toLowerCase())) !== null && _domainEnvPrefixExtra !== void 0 ? _domainEnvPrefixExtra : [],
      _ref2 = (0, _slicedToArray2.default)(_ref, 2),
      envName = _ref2[1];

  if (!envName) {
    throw new Error("The domain prefix can not be determined from ".concat(rootUrl));
  }

  switch (envName) {
    case 'demo':
      return 'DEMO';

    case 'ci':
      return 'CI';

    case 'qed':
      return 'QED';

    default:
      return 'PROD';
  }
}
